module.exports = __webpack_public_path__ + "static/media/comment-edit.f498c298.svg";